var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriarRota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20V15C8 14.0667 7.85833 13.375 7.575 12.925C7.29167 12.475 6.91667 12.0333 6.45 11.6L7.875 10.175C8.075 10.3583 8.26667 10.5543 8.45 10.763C8.63333 10.9717 8.81667 11.1923 9 11.425C9.23333 11.1083 9.471 10.8293 9.713 10.588C9.955 10.3467 10.2007 10.109 10.45 9.875C11.0833 9.29167 11.6583 8.61667 12.175 7.85C12.6917 7.08333 12.9667 5.74167 13 3.825L11.425 5.4L10 4L14 0L18 4L16.6 5.4L15 3.825C14.9667 6.20833 14.6 7.90433 13.9 8.913C13.2 9.92167 12.5 10.7423 11.8 11.375C11.2667 11.8583 10.8333 12.3293 10.5 12.788C10.1667 13.2467 10 13.984 10 15V20H8ZM3.2 6.175C3.13333 5.84167 3.08767 5.475 3.063 5.075C3.03833 4.675 3.01733 4.25833 3 3.825L1.4 5.4L0 4L4 0L8 4L6.575 5.4L5 3.85C5 4.2 5.01667 4.52933 5.05 4.838C5.08333 5.14667 5.11667 5.434 5.15 5.7L3.2 6.175ZM5.35 10.575C5.01667 10.225 4.696 9.81667 4.388 9.35C4.08 8.88333 3.809 8.30833 3.575 7.625L5.5 7.15C5.66667 7.6 5.85833 7.98333 6.075 8.3C6.29167 8.61667 6.525 8.9 6.775 9.15L5.35 10.575Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriarRota);
export default __webpack_public_path__ + "static/media/CriarRota.aa4005edc3f82e38ffbefdf363fbc39c.svg";
export { ForwardRef as ReactComponent };